import(/* webpackMode: "eager" */ "/pupas/app/global-error.tsx")